import { DATE_FORMAT } from '_/space-management/config/date';
import { EventStatus } from '_/space-management/services/models/enums/event-status.enum';
import { EventsModel } from '_/space-management/services/models/events.model';
import { SlotScheduleModel } from '_/space-management/services/models/slots.model';
import { formatDate } from './formatDate';

export function isScheduleBooked(
  schedule: SlotScheduleModel,
  events: EventsModel[],
  selectedDay: string
): boolean {
  return (
    events?.some((event) => {
      if (
        event.status === EventStatus.CANCELED ||
        event.status === EventStatus.REJECTED ||
        event.status === EventStatus.CHECKEDOUT ||
        event.checkoutAt
      ) {
        return false;
      }
      const evStart = new Date(event.startAt);
      const evEnd = new Date(event.endAt);
      if (formatDate(evStart, DATE_FORMAT) !== selectedDay) {
        return false;
      }
      const evStartStr = formatDate(evStart, 'HH:mm');
      const evEndStr = formatDate(evEnd, 'HH:mm');
      return evStartStr < schedule.endTime && evEndStr > schedule.startTime;
    }) || false
  );
}
